/**
 * @typedef {Object} BookingCoveringViewModelType
 * @property {number} id - Unique identifier
 * @property {string} name - Name of the contact who is being covered
 * @property {string} reason - The reason why the booking was created
 */

/**
 * @class
 */
export default class BookingCoveringViewModel {
  /**
   * Create a new BookingCoveringViewModel.
   * @param {...BookingCoveringViewModelType} params
   */
  constructor(params) {
    this.id = params.id
    this.name = params.name
    this.reason = params.reason
  }
}
